import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'
import {type ContentSource, type GetContentSourceRes} from './types'

export const getContentSourceFromServer = (
  accessJwt: string,
  options?: {signal?: AbortSignal},
): Promise<GetContentSourceRes> =>
  wsocFetch<GetContentSourceRes>(
    xrpcPath('eu.wsocial.actor.getContentSource'),
    {method: 'GET', accessJwt, signal: options?.signal},
  )

export const setContentSourceOnServer = (
  accessJwt: string,
  source: ContentSource,
  options?: {signal?: AbortSignal},
): Promise<void> =>
  wsocFetch<void>(xrpcPath('eu.wsocial.actor.setContentSource'), {
    method: 'POST',
    body: {source},
    accessJwt,
    signal: options?.signal,
  })
